import { render, staticRenderFns } from "./app-search-card.vue?vue&type=template&id=569f90e4&scoped=true&"
import script from "./app-search-card.vue?vue&type=script&lang=js&"
export * from "./app-search-card.vue?vue&type=script&lang=js&"
import style0 from "./app-search-card.vue?vue&type=style&index=0&id=569f90e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569f90e4",
  null
  
)

export default component.exports